export default "__VITE_ASSET__a4f22b90__"